import { SIGN_IN_START, SIGN_IN_COMPLETE, SIGN_IN_ERROR, SIGN_OUT, RESET_SIGN_IN_STATE, UPDATE_SIGNED_ACCOUNT_COMPLETE, UPDATE_SIGNED_ACCOUNT_ERROR, UPDATE_SIGNED_ACCOUNT_START } from './types'
import { AccountForFront } from '@mutual-services/pj-panel-types'

export const signInStart = () => ({
  type: SIGN_IN_START
})

export const signInComplete = (account: AccountForFront) => ({
  type: SIGN_IN_COMPLETE,
  payload: account
})

export const signInError = (errorCode: string) => ({
  type: SIGN_IN_ERROR,
  payload: errorCode
})

export const signOut = () => ({
  type: SIGN_OUT
})

export const resetSignInState = () => ({
  type: RESET_SIGN_IN_STATE
})

export const updateSignedAccountStart = () => ({
  type: UPDATE_SIGNED_ACCOUNT_START
})

export const updateSignedAccountComplete = (account: AccountForFront) => ({
  type: UPDATE_SIGNED_ACCOUNT_COMPLETE,
  payload: account
})

export const updateSignedAccountError = (errorCode: string) => ({
  type: UPDATE_SIGNED_ACCOUNT_ERROR,
  payload: errorCode
})
